<ng-container *transloco="let t">
  @if (liveEvent) {
    <div class="live-result">
      <app-live-results-heading [event]="liveEvent" [countries]="countries" [languages]="languages"
                                [type]="LiveResultHeadingType.EVENT" (onClick)="expand()"/>

      @if (isExpanded) {
        <div class="live-races mt-4 mt-xxl-0" @toBottom>
          @for (race of liveEvent.racesList;track race) {
            <app-live-race-list-item [race]="race" [languages]="languages" [countries]="countries"
                                     [event]="liveEvent"></app-live-race-list-item>
          }
        </div>

      }</div>


  }
</ng-container>
